import { getType } from 'typesafe-actions'
import { networkStatusFor, RequestStatus } from './actions'

export const networkRequestStatusReducer = (source: string) => (
  state: RequestStatus | null = null,
  action: { type: string; payload: RequestStatus }
) => {
  switch (action.type) {
    case getType(networkStatusFor(source)):
      return action.payload

    default:
      return state
  }
}
